import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import { Box, Button, Grid, IconButton, InputLabel, MenuItem, Pagination, Select } from '@mui/material';
import Coupons from './Coupons';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import SearchImg from '../../assets/search.svg';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import { ClearIcon } from '@mui/x-date-pickers-pro';
import { MdClear } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import {
  setAllCoupons,
  setFilters,
  setCurrentPage,
  setPagination,
  resetFilters,
  setLoading,
  setError,
} from 'src/redux/slices/couponSlice';

const AllCoupons = () => {
  const { fetchAllCoupon, activeBranchId } = useMain();
  const dispatch = useDispatch();
  const { coupons, filteredCoupons, displayedCoupons, filters, pagination, loading, error } =
    useSelector((state) => state.coupons);

  const getData = async () => {
    try {
      dispatch(setLoading(true));
      const res = await fetchAllCoupon(activeBranchId);
      if (res.statusCode === 200) {
        dispatch(setAllCoupons(res?.data || []));
      }
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    if (activeBranchId) {
      getData();
    }
    return () => {
      dispatch(setAllCoupons([]));
    };
  }, [activeBranchId]);
  useEffect(() => {
    dispatch(resetFilters()); // Reset filters on load
  }, []);


  const handleLimitChange = (e) => {
    dispatch(setPagination({ itemsPerPage: e.target.value, currentPage: 1 }));
  };

  const handlePageChange = (e, value) => {
    dispatch(setCurrentPage(value));
  };

  return (
    <PageContainer title="Manage Coupons" description="This contains all coupons">
      <DashboardCard2 title="Manage Coupons">
        <div style={{ display: 'grid', gridTemplateColumns: '2fr auto' }}>
          <div style={{ marginBottom: '1.7rem' }}>
            <InputLabel>Show per page</InputLabel>
            <Select
              style={{
                borderRadius: '7px',
                border: '0.5px solid #6174DD',
                padding: '4px 12px',
                background: '#FFF',
                height: '40px',
                width: '10%',
              }}
              value={pagination.itemsPerPage}
              onChange={handleLimitChange}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>           <MenuItem value={1000000}>All</MenuItem>

            </Select>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center', gap: '1rem', width: '76%' }}>
            <div style={{ width: '170px', marginBottom: '1.6rem', marginRight: '-1rem', cursor: 'pointer' }}>
              <InputLabel style={{ cursor: 'pointer' }}>Search</InputLabel>
                <div className="search-input" style={{ display: 'flex', alignItems: 'center', width: '100%', boxSizing: 'border-box' }}>
                <img
                  src={SearchImg}
                  alt="Search Icon"
                  style={{ cursor: 'pointer', marginRight: '0.5rem' }}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent the click from bubbling up to the outer div
                    document.getElementById('search-input').focus();
                  }}
                />
                <input
                  id="search-input"
                  placeholder='Search Coupons...'
                  type="text"
                  // placeholder="Search..."
                  value={filters.search}
                  onChange={(e) => dispatch(setFilters({ search: e.target.value }))}
                  style={{ marginLeft: '0.5rem', flex: 1, borderRadius: '7px' }} // Added flex: 1 for better input width
                />
                {filters.search && (
                  <IconButton
                    onClick={() => dispatch(setFilters({ search: '' }))}
                    style={{ padding: 1 }}
                  >
                    <MdClear style={{
                      color: '#000',
                      marginRight: '-0.2rem',
                      marginTop: '0.1rem',
                      fontSize: '1.1rem'
                    }} />
                  </IconButton>
                )}
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <ShowLoader />
        ) :  displayedCoupons?.length > 0 ? (
          <>
            <Box>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={12}>
                  <Coupons data={displayedCoupons}  getCoupons={getData} />
                </Grid>
              </Grid>
            </Box>
          </>
        ) : (
          'No data found'
        )}
         <Box display={'flex'} justifyContent={'flex-end'}>
          <Pagination
            count={pagination.totalPages}
            page={pagination.currentPage}
            color="primary"
            onChange={handlePageChange}
          />
        </Box>
      </DashboardCard2>
    </PageContainer>
  );
};

export default AllCoupons;